function initiateRumSweetenerSelector() {
  document
    .querySelectorAll('.rum-sweetener-selection-block')
    .forEach(block => {
      new window.RumSweetenerSelection(block);
    });
}

if (!window.RumSweetenerSelection) {
  window.RumSweetenerSelection =
    class RumSweetenerSelection {
      constructor(blockElement) {
        this.blockElement = blockElement;
        this.typeOptions = blockElement.querySelectorAll('.rum-sweetener-option');
        this.selectedType = null;

        this.#init();
      }

      #init() {
        this.#addEventListeners();
      }

      #addEventListeners() {
        // Handle rum sweetener selection
        this.typeOptions.forEach((option) => {
          if (!option._clickHandler) {
            option._clickHandler = () => this.#selectRumSweetener(option);
          }
          option.removeEventListener('click', option._clickHandler);
          option.addEventListener('click', option._clickHandler);
        });
      }

      #selectRumSweetener(option) {
        const type = option.dataset.type;

        // Clear previous selections
        this.typeOptions.forEach((opt) => opt.classList.remove('selected'));

        // Select current type
        option.classList.add('selected');
        this.selectedType = type;

        // Dispatch custom event
        this.#dispatchRumSweetenerEvent();
      }

      #dispatchRumSweetenerEvent() {
        document.dispatchEvent(
          new CustomEvent('rum-sweetener-changed', {
            detail: {
              selectedType: this.selectedType
            },
          })
        );
      }

      #getSelection() {
        return {
          selectedType: this.selectedType,
        };
      }

      reset() {
        this.selectedType = null;
        this.typeOptions.forEach((opt) => opt.classList.remove('selected'));
      }
    }
  initiateRumSweetenerSelector();
}

document.addEventListener('DOMContentLoaded', () => {
  initiateRumSweetenerSelector();
});

document.addEventListener('modal-opened', () => {
  initiateRumSweetenerSelector();
});
